export default __webpack_public_path__ + "86764a530d38309adde23cb9689d8519.png";